<template>
  <div style="width: 95%; margin: auto">
    <div class="row justify-content-between">
      <div class="col" v-if="params.mode != 2">
        <button class="button back-button back-absolute tooltip" data-tooltip="Regresar a carrousel" @click="back">
          <svg width="10.975" height="9.998" viewBox="0 0 10.975 9.998">
            <path id="Color_Overlay" data-name="Color Overlay"
              d="M26.825,57.835l-3.549-4.046A.634.634,0,0,1,23,53.244v-.366a.7.7,0,0,1,.068-.308.641.641,0,0,1,.14-.282l3.615-4.122a.439.439,0,0,1,.706.028l.205.267a.706.706,0,0,1-.023.861L25.13,52.268h8.343a.564.564,0,0,1,.5.609v.366a.564.564,0,0,1-.5.609H25.236l2.478,2.825a.708.708,0,0,1,.023.861l-.205.266a.462.462,0,0,1-.365.194A.455.455,0,0,1,26.825,57.835Z"
              transform="translate(-23 -48.001)" />
          </svg>
        </button>
      </div>
      <div class="col center">
        <h1 class="section-title">{{ item.nombre }}</h1>
        <br />
        <label class="sub noPadding">{{ item.inicio }}</label>
        <label class="sub" v-if="item.conductor"> {{ item.conductor }}</label>
      </div>
      <div class="col-auto" style="text-algin: right !important">
        <button class="button icon-button tooltip tooltip-left groupNews" data-tooltip="Refrescar*" @click="reload">
          <font-awesome-icon icon="sync" />
        </button>
        <button class="button icon-button tooltip tooltip-left groupNews" data-tooltip="Descargar*" @click="download">
          <font-awesome-icon icon="cloud-download-alt" />
        </button>
        <button class="button icon-button tooltip tooltip-left groupNews" data-tooltip="Eliminar*" @click="borrar">
          <font-awesome-icon icon="trash-alt" />
        </button>

        <button class="button icon-button tooltip tooltip-left groupNews" :data-tooltip="tooltipHide"
          v-if="params.mode == 2" @click="hide">
          <font-awesome-icon :icon="iconHide" />
        </button>
        <!--<button class="button icon-button tooltip tooltip-left groupNews" data-tooltip="Cerrar*" @click="cerrar" v-if="isOpen">
          X
        </button>-->
      </div>
    </div>

    <panel-text v-if="view" :items="items" :LastEvaluatedKey="LastEvaluatedKey" @goToNote="goToNote"
      @loadMore="loadMore">
    </panel-text>
    <div :class="classBody" v-else>
      <timelinefull v-if="items.length > 0" :items="items" :LastEvaluatedKey="LastEvaluatedKey" :from="params.from"
        :params="params" :isloading="isloading" @loadMore="loadMore" @isOpen="goToNoteFl"></timelinefull>
    </div>
    <div class="separador"></div>
  </div>
</template>

<script>
import timelinefull from "@/components/timelinefull";

import { strings } from "@/services/strings.js";
import moment from "moment-timezone";

import panelText from "@/components/panelText";

import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faSync,
  faChevronDown,
  faChevronUp,
  faTrashAlt,
  faList,
  faCloudDownloadAlt,
} from "@fortawesome/free-solid-svg-icons";
library.add(faSync);
library.add(faChevronDown);
library.add(faChevronUp);
library.add(faTrashAlt);
library.add(faList);
library.add(faCloudDownloadAlt);
export default {
  props: ["params", "fquery", "fLetrero", "view", "ndx"],
  components: { timelinefull, panelText },
  mixins: [strings],
  data() {
    return {
      menuOn: false,
      url: this.$store.getters.getMainUrl,
      providerID: this.$store.state.userInfo.net,
      fi: "",
      item: {},
      items: [],
      medio: "",
      query: {
        fi: {},
        ubicacion: "global",
        fecha: {
          fin: "",
        },
        hora: {
          ini: "00:00",
          fin: "23:59",
        },
        keywords: [],
        reload: true,
      },
      LastEvaluatedKey: 0,
      total: 0,
      limit: 20,
      tooltipHide: "Ocultar",
      iconHide: "chevron-up",
      classBody: [],
      isloading: false,
      isOpen: false
    };
  },
  sockets: {
   onmessage(data) {
     this.handleIncomingMessage(data.data);
   },
 },
  computed: {
    token() {
      return this.$store.getters.getToken;
    },
  },
  beforeMount() {
    window.scrollTo(0, 0);
    this.init();
  },
  watch: {
    /*fquery(){ //que no cambie de fecha las escaletas guardadas  (20/01/21)
            console.log('changed fquery')
            this.LastEvaluatedKey = 0;
            this.total = 0;
            this.items = [];
            //this.query.fecha.ini = this.fquery;
            this.query.fecha.fin = this.fquery;
            //this.setItems();
            this.getItems();
        }*/
  },
  methods: {
    handleIncomingMessage(data) {
      try {
          let parsedData = JSON.parse(data);
        if (this.isValidNota(parsedData)) {
            switch (parsedData.entrada) {
            case "T":
            case "R":
            this.agregaNotasOffWss(parsedData);
              break;
            case "PD":
            this.agregaNotasOffPDWss(parsedData);
              break;
            case "FB":
            case "TW":
            case "Y":
            case "I":
            this.agregaNotasONWss(parsedData);
            break;
            case "TK":
            this.agregaNotasTitktok(parsedData);
              break;
          }
        } else {
          console.warn('Datos no válidos recibidos:', parsedData);
        }
      } catch (e) {
        // Registro del error y datos para depuración
        console.error('Error al analizar los datos recibidos:', data, e);
      }
    },
    isValidNota(data) {
      console.log(data)
      if (
        data 
      ) {
        return true;
      }
      return false;
    },
    agregaNotasOffWss(data) {
      var self = this;
      let condigo = this.params.item.key;
      let codigoNota = data.codigo_noticiero;
      if(condigo == codigoNota){
        self.items = [].concat(data,self.items)
      }
    },
    agregaNotasOffPDWss(data) {
      var self = this;
      let condigo = this.params.item.key;
      let codigoNota = data.key_src;
      if(condigo == codigoNota){
        self.items = [].concat(data,self.items)
      }
    },
    agregaNotasTitktok(data) {
      var self = this;
      let condigo = this.params.item.key;
      let codigoNota = data.autor;
      if(condigo == codigoNota){
        self.items = [].concat(data,self.items)
      }
    },
    agregaNotasONWss(data) {
      var self = this;
      let condigo = this.params.item.key;
      let codigoNota = data.key_src;
      if(condigo == codigoNota){
        self.items = [].concat(data,self.items)
      }
    },
    init() {
      console.log(this.params);
      var key = this.params.item.key;
      this.fi = this.params.fi;
      this.item = this.params.item;
      this.LastEvaluatedKey = this.params.LastEvaluatedKey;
      this.items = this.params.items;
      //this.setItems(this.params.items);
      this.medio = this.params.entrada;
      this.getConfig();
      if (this.params.mode == 2) {
        this.getItems();
      }
    },
    getItems() {
      var self = this;
      this.query.LastEvaluatedKey = this.LastEvaluatedKey;
      axios
        .post(self.url + "queryElasticsearch", JSON.stringify(self.query))
        .then((response) => {

          if (response.data.success) {
            var result = JSON.parse(response.data.data);
            if (self.items.length > 0) {
              self.items = [].concat(self.items, result.result[self.medio]);
            } else {
              self.items = result.result[self.medio];
            }

            self.total = result.total;
            self.LastEvaluatedKey =
              self.limit + self.LastEvaluatedKey > self.total
                ? -1
                : self.limit + self.LastEvaluatedKey;
            self.isloading = false;
            setTimeout(function () { }, 200);
          }
        });
    },
    /*async getItems() {

            var self = this;
            this.query.LastEvaluatedKey = this.LastEvaluatedKey;
            return new Promise(resolve=>{
                axios
                .post(self.url + "queryElasticsearch", JSON.stringify(self.query))
                .then(response => {
                    var items = [];
                    if (response.data.success) {
                        var result = JSON.parse(response.data.data);
                        items = result.result[self.medio];
 
                        self.total = result.total;
                        self.LastEvaluatedKey =
                        self.limit + self.LastEvaluatedKey > self.total
                            ? -1
                            : self.limit + self.LastEvaluatedKey;
                    }
                    resolve(items);
                });
            })
            
        },*/
    async getNotes(items) {
      if (items.length > 0) {
        var mis_items = [];
        for (var i in items) {
          var item = items[i];
          var r = await this.getItem(item);
          if (r.success) {
            var db_item = r.data;
            var note = {
              key: db_item.key,
              titulo: db_item.titulo,
              fecha: db_item.publicado_utc,
              thumb: db_item.thumb,
              entrada: db_item.entrada,
              descripcion: db_item.descripcion,
            };
            if (item.entrada == "R" || item.entrada == "T") {
              note.dur = db_item.descripcion
                ? db_item.descripcion.duracion
                : null;
              note.descripcion = null;
            }
            if (db_item.metadatos) {
              var metadata_item = db_item.metadatos;
              note.titulo = metadata_item.titulo
                ? metadata_item.titulo
                : note.titulo;
              note.thumb = metadata_item.imagen
                ? metadata_item.imagen
                : note.thumb;
            }
            mis_items.push(note);
          }
        }
        return mis_items;
      }
    },
    getItem(item) {
      var post_data = {
        token: this.token,
        key: item.key,
        entrada: item.entrada,
        logs:true
      };
      var self = this;
      return new Promise((resolve) => {
        axios
          .post(this.url + "getNote", JSON.stringify(post_data)) //petición
          .then((response) => {
            resolve(response.data);
          })
          .catch(function (error) {
            var response = { success: false, error: error };
            console.log(error);
          });
      });
    },
    back() {
      this.$emit("back");
    },
    getConfig() {
      this.titulo = this.item.nombre;
      var arr = [];

      arr.push(this.item.key);
      switch (this.medio) {
        case "T":
          this.query.fi = { T: arr };
          break;
        case "R":
          this.query.fi = { R: arr };
          break;
        case "TW":
          this.query.fi = { TW: arr };
          break;
        case "FB":
          this.query.fi = { FB: arr };
          break;
        case "Y":
          this.query.fi = { Y: arr };
          break;
        case "PD":
          this.query.fi = { PD: arr };
          break;
        case "I":
          this.query.fi = { I: arr };
          break;
        case "TK":
          this.query.fi = { TK: arr };
          break;
      }
      this.query.limit = this.limit;
      //this.query.fecha.ini = this.fquery;

      if (this.item.fecha) {
        this.query.fecha.fin = this.item.fecha;
      } else {
        this.query.fecha.fin = this.fquery;
      }
    },
    async loadMore() {
      this.isloading = true;
      if (this.LastEvaluatedKey) {
        this.getItems();
      }
    },
    async setItems(items) {
      console.log("setItems: ", items.length);
      var new_items = await this.getNotes(items);
      if (this.items.length > 0) {
        this.items = [].concat(this.items, new_items);
      } else {
        this.items = new_items;
      }
    },
    goToNoteFl() {
      console.log("-*-*-*-*-*-**-*-*-*");
      this.isOpen = true;
      //this.$emit("goToNoteTimelineFl", params);
    },
    reload() {
      this.items = [];
      this.LastEvaluatedKey = 0;
      this.getItems();
    },
    cerrar(){
      this.isOpen = false;
    },
    download() {
      this.query.titulo = this.titulo;
      this.$emit("download", this.query);
    },
    borrar() {
      this.$emit("borrar", this.ndx);
    },
    hide() {
      if (this.classBody.indexOf("hidden") == -1) {
        //ocultamos
        this.iconHide = "chevron-down";
        this.tooltipHide = "Mostrar";
        this.classBody.push("hidden");
      } else {
        //mostramos
        this.iconHide = "chevron-up";
        this.tooltipHide = "Ocultar";
        this.classBody.pop();
      }
    },
  },
};
</script>
<style scoped>
.back-button {
  padding: 0;
  width: 27px;
  height: 27px;
  border-radius: 5px;
}

.back-button svg {
  fill: #00b99e;
}

.back-button:hover svg {
  fill: #fff;
}

.section-title {
  padding: 0 !important;
  font-size: 1.8rem !important;
  margin: 0 !important;
}

.sub {
  color: #00b99e;
  text-align: center;
}

.separador {
  margin-top: 1%;
  width: 98%;
  margin-left: auto;
  margin-right: auto;
  height: 10px;
  border-top: 1px solid #00b99e;
}

.groupNews {
  background: none !important;
  color: white !important;
}

.hidden {
  display: none;
}
</style>